import renderHTML from 'react-render-html';
import format from 'string-template';
import _ from 'lodash';

/**
 * Retourne du DOM React à partir d'une string contenant des balises HTML et remplace les variables ({0}, {1}....) avec params
 * @param {String} html string contenant des balises html
 * @param {Spread Operator, variable de tout type possible} params variables à remplacer dans la string 'html'
 * example :    html = '<p>L'ardèche c'est {0} mieux que les {1} autres département français.</p>'
 *              params = '100 fois mieux', 101
 *              resultat = <p>L'ardèche c'est 100 fois mieux mieux que les 101 autres département français.
 */
export function convertHtmlToReactDomWithParams(html, ...params) {
    return _.isString(html) && html !== '' ? renderHTML(format(html, params)) : '';
}



// WEBPACK FOOTER //
// ./src/utils/htmlUtils.js